import { actions, calloutInformation, calloutWarning, contentWrapper, dismissIcon, dismissIconWarning, iconContainer, infoIcon, warningIcon, message, title, } from '../styles/legacy';
import { actions as actionsCitron, calloutError, calloutWarning as calloutWarningCitron, calloutPending, calloutInformation as calloutInformationCitron, calloutNeutral, calloutSuccess, contentWrapper as contentWrapperCitron, dismissIcon as dismissIconCitron, dismissIconWarning as dismissIconWarningCitron, iconContainer as iconContainerCitron, infoIcon as infoIconCitron, warningIcon as warningIconCitron, errorIcon, neutralIcon, pendingIcon, successIcon, message as messageCitron, title as titleCitron, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var CalloutError = citrusStyled.div('calloutError', calloutError);
export var CalloutWarning = citrusStyled.div('calloutWarning', {
    legacy: calloutWarning,
    citrus2022: calloutWarningCitron,
});
export var CalloutPending = citrusStyled.div('calloutPending', calloutPending);
export var CalloutInformation = citrusStyled.div('calloutInformation', {
    legacy: calloutInformation,
    citrus2022: calloutInformationCitron,
});
export var CalloutNeutral = citrusStyled.div('calloutNeutral', calloutNeutral);
export var CalloutSuccess = citrusStyled.div('calloutSuccess', calloutSuccess);
export var IconContainer = citrusStyled.div('iconContainer', {
    legacy: iconContainer,
    citrus2022: iconContainerCitron,
});
export var Message = citrusStyled.div('message', { legacy: message, citrus2022: messageCitron });
export var Actions = citrusStyled.div('actions', { legacy: actions, citrus2022: actionsCitron });
export var DismissIcon = citrusStyled.i('dismissIcon', { legacy: dismissIcon, citrus2022: dismissIconCitron });
export var DismissIconWarning = citrusStyled.i('dismissIconWarning', {
    legacy: dismissIconWarning,
    citrus2022: dismissIconWarningCitron,
});
export var InfoIcon = citrusStyled.i('infoIcon', { legacy: infoIcon, citrus2022: infoIconCitron });
export var ErrorIcon = citrusStyled.i('errorIcon', errorIcon);
export var NeutralIcon = citrusStyled.i('neutralIcon', neutralIcon);
export var PendingIcon = citrusStyled.i('pendingIcon', pendingIcon);
export var SuccessIcon = citrusStyled.i('successIcon', successIcon);
export var WarningIcon = citrusStyled.i('warningIcon', { legacy: warningIcon, citrus2022: warningIconCitron });
export var Title = citrusStyled.h3('title', { legacy: title, citrus2022: titleCitron });
export var ContentWrapper = citrusStyled.div('contentWrapper', {
    legacy: contentWrapper,
    citrus2022: contentWrapperCitron,
});
export var Styled = {
    Actions: Actions,
    CalloutWarning: CalloutWarning,
    ContentWrapper: ContentWrapper,
    DismissIcon: DismissIcon,
    DismissIconWarning: DismissIconWarning,
    IconContainer: IconContainer,
    InfoIcon: InfoIcon,
    NeutralIcon: NeutralIcon,
    WarningIcon: WarningIcon,
    Message: Message,
    Title: Title,
};
